import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import WaitlistAdmin from "../components/WaitlistAdmin";
import SeoHead from "../components/seo/SeoHead";

const THEME_KEY = "hookora_theme";

function WaitlistAdminPage() {
  const getStoredTheme = () => {
    if (typeof window === "undefined") return "light";
    return localStorage.getItem(THEME_KEY) || "light";
  };

  const [theme, setTheme] = useState(getStoredTheme());

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const syncTheme = () => {
      setTheme(localStorage.getItem(THEME_KEY) || "light");
    };

    window.addEventListener("storage", syncTheme);
    window.addEventListener("hookora-preferences-updated", syncTheme);

    return () => {
      window.removeEventListener("storage", syncTheme);
      window.removeEventListener("hookora-preferences-updated", syncTheme);
    };
  }, []);

  const isDark = theme === "dark";

  const colors = useMemo(
    () => ({
      pageBg: isDark ? "#020617" : "#f8fafc",
      pageGradient: isDark
        ? "radial-gradient(circle at top left, rgba(59,130,246,0.12), transparent 28%), radial-gradient(circle at top right, rgba(124,58,237,0.10), transparent 24%)"
        : "none",
      text: isDark ? "#f8fafc" : "#111827",
      buttonShadow: isDark
        ? "0 10px 24px rgba(37, 99, 235, 0.28)"
        : "0 10px 24px rgba(37, 99, 235, 0.22)"
    }),
    [isDark]
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        background: colors.pageBg,
        backgroundImage: colors.pageGradient
      }}
    >
      <SeoHead
        title="Waitlist Admin | Hookora"
        description="Review billing-interest leads and waitlist activity inside Hookora admin."
        path="/admin/waitlist"
      />
      <Navbar />

      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "20px 16px 0"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "14px"
          }}
        >
          <Link
            to="/admin/milestone-watch"
            style={{
              textDecoration: "none",
              background: "linear-gradient(135deg, #2563eb, #7c3aed)",
              color: "#ffffff",
              padding: "12px 16px",
              borderRadius: "12px",
              fontWeight: "700",
              boxShadow: colors.buttonShadow
            }}
          >
            Open Milestone Watch
          </Link>
        </div>
      </div>

      <WaitlistAdmin />
    </div>
  );
}

export default WaitlistAdminPage;